import React from "react";
import { Button, message } from "antd";
import { successTitle, successSubtitle } from "../../pages/Users/styles";
import { CustomIcons } from "../../assets";
import NewUserForm from "../Forms/NewUser";
import { Dispatcher } from "../../util/helpers";
import { usePostResponderAdmin } from "../../hooks/useAdmin";
import { copyObjects } from "../../util/copyObjects";
import NewResponderAdminUser from "./NewResponderAdminUser";

interface NewResponderAdminsProp {
  ResponderCompanyId: number | null;
  setCloseDrawer: Dispatcher<boolean>;
  refetchAdmins: () => void;
}

const NewResponderAdmin = ({
  ResponderCompanyId,
  setCloseDrawer,
  refetchAdmins,
}: NewResponderAdminsProp) => {
  const addResponderAdmin = usePostResponderAdmin();
  const [messageApi, contextHolder] = message.useMessage();
  const messageKey = "createResponderAdmin";

  const destroyMessage = () => {
    messageApi.destroy(messageKey);
  };

  const handleAddUser = async (user: IResponderAdminUser) => {
    if (ResponderCompanyId) {
      try {
        messageApi.open({
          key: messageKey,
          type: "loading",
          content: "Creating Community admin..",
          duration: 0,
        });

        const responderAdmin: IAddResponderAdmin = copyObjects(user, {
          ResponderCompanyId: ResponderCompanyId || 0,
        });
        await addResponderAdmin.mutateAsync(responderAdmin);
        refetchAdmins();
        messageApi.open({
          key: messageKey,
          type: "success",
          content: "Created Responder Company admin..",
          duration: 0,
        });
        setTimeout(() => {
          destroyMessage();
        }, 2000);
      } catch (error) {
        destroyMessage();
        console.error(error);
      }
    } else {
      message.error("Responder Company not found");
    }
  };

  const handleClose = async () => {
    setCloseDrawer(false);
    addResponderAdmin.reset();
  };
  return (
    <div>
      {contextHolder}
      {addResponderAdmin.isSuccess ? (
        <div className="flex w-full h-full gap-2 flex-column align-items-center justify-content-center">
          <div className="flex w-full justify-content-center">
            <CustomIcons.SuccessIcon
              width={100}
              height={100}
              viewBox={null}
              svgColor="#179717"
            />
          </div>
          <div style={successTitle}> Successful</div>
          <div style={successSubtitle} className="pb-4">
            {" "}
            You have successfully added a new admin
          </div>
          <Button
            type="primary"
            ghost
            onClick={handleClose}
            size="large"
            className="w-4"
          >
            close
          </Button>
        </div>
      ) : (
        <NewResponderAdminUser
          onFormFinish={async (responderUser: IResponderAdminUser) =>
            handleAddUser(responderUser)
          }
          onModalClose={() => {
            handleClose();
          }}
          isLoading={addResponderAdmin.isPending}
          isSuccess={addResponderAdmin.isSuccess}
        />
      )}
    </div>
  );
};

export default NewResponderAdmin;
